const STORAGE_KEY = 'active_module';

/**
 * Returns the active module for this session, migrating from the legacy
 * 'active_discipline' key if present.
 */
export const getActiveModule = () => {
  const legacy = localStorage.getItem('active_discipline');
  if (legacy && !localStorage.getItem(STORAGE_KEY)) {
    localStorage.setItem(STORAGE_KEY, legacy);
    localStorage.removeItem('active_discipline');
  }
  return localStorage.getItem(STORAGE_KEY);
};

/** Persists the active module for this session. */
export const setActiveModule = (value) => {
  if (value) localStorage.setItem(STORAGE_KEY, value);
};

/** Clears the active module on logout (also removes legacy key). */
export const clearActiveModule = () => {
  localStorage.removeItem(STORAGE_KEY);
  localStorage.removeItem('active_discipline');
};

/**
 * Returns true if the stored activeModule is still valid for the given user.
 * Super admins and admins pass all non-null modules.
 */
export const isActiveModuleValid = (activeModule, user) => {
  if (!activeModule) return false;
  if (activeModule === 'admin') return !!(user?.is_admin || user?.is_super_admin);
  if (user?.is_super_admin || user?.is_admin) return true;
  return user?.discipline_access?.[activeModule] === true;
};
